/**
 * Created by Claude on 14.08.2026
 */

const TravelMapWindow = Prefab.createWindow(
    "travel_map",
    "travelmapwindow_prefab_json",
    {
        name: "travelmapwindow",
        bundles: ["travel_map_backgrounds"]
    }
);